import { SyntheticEvent, useState } from "react";
import { useSelector } from "react-redux";
import { StyledFloatingInput, StyledFloatingInputTypes } from "src/components";
import { AppState, ConversationTag } from "src/store";
import styles from "./styles.module.scss";
import { TagsDropdown } from "src/containers/conversations/components/conversations-filters/components/tags-dropdown/tags-dropdown";
import { MPDSelect } from "src/mpd-library";
import { QueuesDropdown } from "src/containers/conversations/components/chat/components/chat-sub-header/components/queues-dropdown/queues-dropdown";
import { Position } from "@blueprintjs/core";

const classname = "new-button";

type DraggableNewButtonContentProps = {
    id: string;
    name: string;
    onRemoveButton: (id: string) => void;
    onButtonNameChange: (id: string, name: string) => void;
};

export const DraggableNewButtonContent = ({
    id,
    name,
    onRemoveButton,
    onButtonNameChange
}: DraggableNewButtonContentProps) => {
    const allTags = useSelector((state: AppState) => state.conversations.tags);
    const existingTags = useSelector(
        (state: AppState) => state.profileAutomations.conversations_settings.greeting_tags
    );
    const [checkedTags, setCheckedTags] = useState<any>(
        existingTags.reduce((accumulator: any, tag: ConversationTag) => ({ ...accumulator, [tag.id]: true }), {})
    );
    const [selectedTags, setSelectedTags] = useState<Array<ConversationTag>>([]);

    const selectTag = (updatedCheckedTags, id: string) => {
        let updatedSeelctedTags = [...selectedTags];
        if (updatedCheckedTags[id]) {
            updatedSeelctedTags.push(allTags.find((tag: ConversationTag) => tag.id === id));
        } else {
            updatedSeelctedTags = updatedSeelctedTags.filter((tag: ConversationTag) => tag.id !== id);
        }
        setSelectedTags(updatedSeelctedTags);
        setCheckedTags(updatedCheckedTags);
    };

    const onNameChange = (event: SyntheticEvent) => {
        const { value } = event.target;
        onButtonNameChange(id, value);
    };

    return (
        <div className={styles[classname]}>
            <button className={"remove-new-button"} onClick={() => onRemoveButton(id)}>
                <div className={"remove-new-button-line"} />
            </button>
            <div className={styles[`${classname}-input-wrapper`]}>
                <StyledFloatingInput
                    autoCapitalize="none"
                    autoCorrect="none"
                    floatingType={StyledFloatingInputTypes.primary}
                    value={name}
                    onChange={onNameChange}
                    // placeholder="QUEUE NAME"
                    tabIndex={1}
                    isMaxLengthRequire={false}
                    showErrorText={false}
                    className={styles[`${classname}-name-input`]}
                />
            </div>
            <div className={styles[`${classname}-input-wrapper`]}>
                <MPDSelect
                    className={styles[`${classname}-queue-select`]}
                    defaultValue={"Return"}
                    position={Position.BOTTOM_LEFT}
                    customOptions={<QueuesDropdown />}
                />
            </div>
            <div className={styles[`${classname}-input-wrapper`]}>
                <TagsDropdown
                    setTagsToFilter={selectTag}
                    checkedTags={checkedTags}
                    dropdownWithSearchClassName={styles[`${classname}-tags-dropdown`]}
                />
            </div>
        </div>
    );
};
